/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Panel_ToggleInputs */

const cs_calendar_panel_toggle = /** @type {(inputs: Calendar_Panel_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel kategorií`)
};

const en_calendar_panel_toggle = /** @type {(inputs: Calendar_Panel_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category panel`)
};

/**
* | output |
* | --- |
* | "Category panel" |
*
* @param {Calendar_Panel_ToggleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_panel_toggle = /** @type {((inputs?: Calendar_Panel_ToggleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Panel_ToggleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_panel_toggle(inputs)
	return cs_calendar_panel_toggle(inputs)
});